import type { TRequiredIfRule } from '../mappers';
import type { IDirectoriesStorage } from 'src/services/directories-storage-service/directories-storage-service';

import { compareDataWithFilterItems } from './compare-data-with-filter-items';
import { mapFilterRuleItems } from './map-filter-rule-items';

export const handleRequiredIfRule = (
  directoryService: IDirectoriesStorage,
  recordData: Record<string, unknown>,
  rule: TRequiredIfRule,
): { isRequired: boolean } => {
  const filters = mapFilterRuleItems(rule.ruleView.requirednessRules, directoryService, recordData);

  return { isRequired: compareDataWithFilterItems(recordData, filters) };
};
